import { BidInterestRequestType } from "../../../../hoc";

export const AUCTION_PAGE_SIZE = 48;

export const PROPERTY_TYPE = {
  AUCTION: "auction-properties",
  PRIATE: "private-properties",
};

export const REQUEST_TYPES = {
  AUCTION_PROPERTY_IMAGES:
    "auction_property_images_requested" as BidInterestRequestType,
  PRIVATE_PROPERTY_IMAGES:
    "private_property_images_requested" as BidInterestRequestType,
} as const;

export type RequestType = (typeof REQUEST_TYPES)[keyof typeof REQUEST_TYPES];
